module.exports = __webpack_public_path__ + "img/1440.82f9c05b.svg";